import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_HOST
})

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 403) {
            window.location.href = '/'
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;